module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal modal-mask",
    staticStyle: {
      "display": "block"
    }
  }, [_c('hamburger', {
    on: {
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header",
    on: {
      "click": _vm.categoryClicked
    }
  }, [_c('p', [_vm._v("For Your Consideration")]), _vm._v(" "), _c('img', {
    staticClass: "title",
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/threebb_logo.png",
      "alt": "Three Bill"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [(_vm.modaltype == 'menu') ? _c('categories', {
    attrs: {
      "data": "test",
      "categories": _vm.categories
    },
    on: {
      "clicked": _vm.categoryClicked
    }
  }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e93a7226","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 240
// module chunks = 0